import type { NormalizeOAS, OASOutput } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';
import { SubscriptionTier } from '../../types/Organization';

type O = NormalizeOAS<typeof openapi>;
type ResponseBody = OASOutput<O, '/api/current-pricing-plan', 'get'>;

type SubscriptionPlan = {
  isSCORMExportAllowed: boolean;
  isXAPIExportAllowed: boolean;
  isiOsExportAllowed: boolean;
  isPackageWithInMemoryClientAllowed: boolean;
  isDispatchScormAllowed: boolean;
  pricingPlanType: SubscriptionTier;
  numberOfCourses: number | null;
  scenesPerCourse: number | null;
  storageSpaceInGB: number;
  removedWatermark: boolean;
};

type Result = {
  plan: SubscriptionPlan;
  numberOfSeats: number;
};

export const getSubscriptionPlanFactory = (apiClient: ApiClient) => {
  const getSubscriptionPlan = async () => {
    const response = await apiClient['/api/current-pricing-plan'].get();
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    const plan = response.plan;
    return {
      plan: {
        isSCORMExportAllowed: plan.isSCORMExportAllowed,
        isXAPIExportAllowed: plan.isXAPIExportAllowed,
        isiOsExportAllowed: plan.isiOsExportAllowed,
        isPackageWithInMemoryClientAllowed: plan.isPackageWithInMemoryClientAllowed,
        isDispatchScormAllowed: plan.isDispatchScormAllowed,
        pricingPlanType: plan.pricingPlanType,
        numberOfCourses: plan.numberOfCourses ?? null,
        scenesPerCourse: plan.scenesPerCourse ?? null,
        storageSpaceInGB: plan.storageSpaceInGB,
        removedWatermark: plan.removedWatermark,
      },
      numberOfSeats: response.numberOfSeats,
    };
  };

  return getSubscriptionPlan;
};
